import { combineReducers, createStore as createReduxStore, applyMiddleware } from "redux";
import honeybadgerMiddleware from "Redux/Middleware/honeybadgerMiddleware";
import { composeWithDevTools } from "redux-devtools-extension/developmentOnly";
import createSagaMiddleware from "redux-saga";
import { fork } from "redux-saga/effects";

import { accountSetting } from "./reducers";
import { rootSaga as apiSaga } from "./sagas";

import type { Store, CombinedReducer } from "redux";

export type State = {
  accountSetting: any;
};

export type Action = {
  readonly type: string;
  readonly payload: any;
};

const rootReducer: CombinedReducer<State, Action> = combineReducers({
  accountSetting,
});

const sagaMiddleware = createSagaMiddleware();

function* rootSaga() {
  yield fork(apiSaga);
}

const createStore = (initialState: Partial<State>): Store<State, Action> => {
  const store = createReduxStore(rootReducer, initialState, composeWithDevTools(applyMiddleware(sagaMiddleware, honeybadgerMiddleware)));

  sagaMiddleware.run(rootSaga);
  return store;
};

export default createStore;
